import React from "react";
import clsx from "clsx";

/**
 * BlackTieDo wordmark - a custom typographic lockup.
 * Black + Tie set in Cormorant Garamond (with italic mid-word),
 * Do set in a lighter geometric sans (Outfit) in gold.
 */
export const Wordmark = ({ size = "sm", className, dataTestId = "wordmark" }) => {
  const sizes = {
    xs: "text-lg",
    sm: "text-xl md:text-2xl",
    md: "text-3xl md:text-4xl",
    lg: "text-5xl md:text-7xl",
    xl: "text-[14vw] leading-[0.85]",
  };
  return (
    <span
      data-testid={dataTestId}
      className={clsx(
        "inline-flex items-baseline select-none",
        sizes[size],
        className,
      )}
    >
      <span className="font-serif-display font-semibold tracking-tight text-[color:var(--bt-ink)]">
        Black
      </span>
      <span className="font-serif-display italic font-light text-[color:var(--bt-ink)]">
        Tie
      </span>
      <span className="font-ui font-medium text-[color:var(--bt-gold)] ml-[0.05em]">
        Do
      </span>
      <span
        aria-hidden
        className="font-ui font-light text-[color:var(--bt-gold)]/60 text-[0.35em] ml-[0.15em] translate-y-[-0.4em]"
      >
        ●
      </span>
    </span>
  );
};

export default Wordmark;
